<!-- Zweck: Stellt die HTML-Struktur für shop dialogs scan2warenkorb component im Frontend bereit. -->
<div class="scan2warenkorb">
  <div mat-dialog-title>
    <h1 style="float: left">
      <svg-icon>plus</svg-icon>
      Schnelles Hinzufügen
    </h1>
    <div style="float: right">
      <button mat-flat-button (click)="close()" matTooltip="Schließen">
        <svg-icon>error-clean</svg-icon>
      </button>
    </div>
    <div style="clear: both"></div>
  </div>

  <div mat-dialog-content>
    <div style="text-align: center; padding-top: 10px">
      <span style="font-size: 16px">
        Hinzuzufügende Menge: <span style="font-weight: bold">{{amount}}</span>
      </span>
    </div>
    <div style="padding: 20px; text-align: center">
      <div class="search-box">
        <mat-form-field [appearance]="'outline'" style="width: 400px">
            <mat-label>
              Suche / Barcode / Menge
            </mat-label>
          <input matInput [(ngModel)]="searchValue" (keydown)="preventBrowserZoom($event)" (keydown.enter)="search()" (keydown.f6)="$event.preventDefault(); $event.stopPropagation()" [matAutocomplete]="auto"
                 #autocompleteTrigger="matAutocompleteTrigger" #input>
          <mat-hint>Min. 3 Zeichen benötigt</mat-hint>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="showArtLabel" (optionSelected)="selectedArticleOption($event)">
            @for (art of searchArticles|async; track art) {
              <mat-option [value]="art">
                {{art.label}} <article-dtp-icon [isDtp]="art.IstDtpArtikel"></article-dtp-icon>
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button (click)="search()" mat-flat-button matTooltip="Suchen">
          <svg-icon>suche</svg-icon>
        </button>
      </div>
    </div>

    <div style="text-align: center; padding: 20px">

      <mat-hint>Per Mengeneingabe kann die hinzuzufügende Menge geändert werden.</mat-hint>

      <mat-checkbox [(ngModel)]="force" (change)="forceChange()" matTooltip="Artikel wird immer hinzugefügt. Egal ob bereits bestellt usw.. Wenn bereits im Warenkorb wird die Menge erhöht">Immer hinzufügen</mat-checkbox>
      <mat-checkbox [(ngModel)]="searchImport" (change)="changeImport()" matTooltip="Soll auch ein Import Artikel berücksichtig werden?">Import berücksichtigen</mat-checkbox>
      @if (error|async) {
        <h3 style="color: red; text-align: center; padding-top: 20px">{{error|async}}</h3>
      }
    </div>

    @if ((lastAddedArticles|async)?.length > 0) {
      <div style="text-align: center;">
        <div style="text-align: left; padding: 20px; display: inline-block;">
          <span style="font-weight: bold">
            Letzte ({{lastAddedArticlesLimit}}) gescannte Artikel:
          </span>
          <ul>
            @for (a of lastAddedArticles|async; track a) {
              <li>{{a|ArtikelLabel}} <article-dtp-icon [isDtp]="a.IstDtpArtikel"></article-dtp-icon></li>
            }
          </ul>
        </div>
      </div>
    }
  </div>
</div>
